<template>
  <section style="margin-top: 200px !important">
    <v-card>
      <v-row class="px-10">
        <v-col lg="3" md="3" sm="3">
          <v-select
            :items="[
              { name: '1. Монгол xэл', languageType: 1 },
              {
                name: '2. Англи xэл',
                languageType: 2,
              },
              {
                name: '3. Монгол бичиг',
                languageType: 3,
              },
            ]"
            v-model="selectedLanguageType"
            item-text="name"
            item-value="languageType"
            return-object
          >
          </v-select>
        </v-col>
        <v-col>
          <v-checkbox
            :label="
              showLessonCode
                ? 'Xичээлийн кодыг xаруулав'
                : 'Xичээлийн кодыг xаруулаxгүй'
            "
            v-model="showLessonCode"
          >
          </v-checkbox>
        </v-col>
      </v-row>
    </v-card>
    <v-card
      class="mx-auto pt-5 pb-10"
      id="printMe"
      v-if="item && item.code && item.code == '001'"
    >
      <div
        style="
          position: relative;
          width: 29.7cm;
          height: 21cm;
          border: 1px solid black;
          margin: 0 auto;
          font-size: 6pt;
        "
      >
         <div  style="
        width: 914.646px;
        height: 415.748px;
        background-color: bisque;
        position: absolute;
        left: 151.18px;
        top: 170.08px;
        border: 1px solid black;
      ">

         </div>
      </div>
    </v-card>

    <v-container class="mt-2">
      <v-row justify="center">
        <v-btn class="secondary mx-auto" @click="_print">Xэвлэx</v-btn>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Table3Score from "./Table3Score.vue";
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  components: {},
  data: () => ({
    showLessonCode: false,
    selectedLanguageType: null,
    curriculum: null,
    showDetails: false,
    allCreditPoints: null,
    allScore: 0,
    allCounter: 0,
    allCredit: 0,
    loading: true,
    yearScores: {},
    years: null,
    studentScores: null,
    value: "",
    nochange: true,
    name: null,
    description: null,
    signature: null,
    item: null,
  }),
  watch: {},
  props: {
    itemRefPath: {
      required: true,
      type: String,
    },
    student: {
      required: true,
      type: Object,
    },
    ui_setting: {
      required: true,
      type: Object,
    },
  },
  components: {
    Table3Score,
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    calculatedScoreTotal() {
      var xEnteredYear = 2019;
      var xCurrentYear = 2023;
      var sum = 0;
      if (this.yearScores) {
        for (var i = xEnteredYear; i <= xCurrentYear; i++) {
          var datas = this.yearScores[i + "-" + (i + 1 + "-1")];
          if (datas && datas.length > 0) {
            for (var k = 0; k < datas.length; k++) {
              if (datas[k].lesson && datas[k].lesson.credit) {
                sum = sum + parseFloat(datas[k].lesson.credit);
              }
            }
          }
        }
      }
      return sum;
    },
  },
  created() {
    console.log(this.ui_setting);
    this.selectedLanguageType = { name: "1. Монгол xэл", languageType: 1 };
    this.student.xcurriculum.ref.onSnapshot((doc) => {
      let curriculum = doc.data();
      curriculum.id = doc.id;
      curriculum.ref = doc.ref;
      curriculum.lessons = null;
      curriculum.ref.collection("curriculums-lessons").onSnapshot((docs) => {
        curriculum.lessons = [];
        var counter = 0;
        docs.forEach((doc) => {
          counter++;
          let lesson = doc.data();
          lesson.id = doc.id;
          lesson.ref = doc.ref;
          lesson.index = counter;
          //lessonStandardRef
          lesson.lessonStandard.ref.onSnapshot((doc) => {
            let x = doc.data();
            x.id = doc.id;
            x.ref = doc.ref;
            lesson.lessonStandard = x;
          });
          curriculum.lessons.push(lesson);
        });
      });
      this.curriculum = curriculum;
    });

    var xEnteredYear = 2019;
    var xCurrentYear = 2023;
    for (var i = xEnteredYear; i <= xCurrentYear; i++) {
      this.yearScores[i + "-" + (i + 1) + "-" + 1] = [];
      this.yearScores[i + "-" + (i + 1) + "-" + 2] = [];
    }

    fb.db
      .doc(this.itemRefPath)
      .get()
      .then((doc) => {
        this.item = doc.data();
        this.item.ref = doc.ref;
        this.item.id = doc.id;
        this.name = this.item.name;

        var description = this.item.description;

        if (this.student.lastName && description)
          description = description.replaceAll(
            "$$LASTNAME",
            this.student.lastName
          );
        if (this.student.firstNamee && description)
          description = description.replaceAll(
            "$$FIRSTNAME",
            this.student.firstName
          );
        if (
          this.student.xprofession &&
          this.student.xprofession.namee &&
          description
        )
          description = description.replaceAll(
            "$$PROFESSION",
            this.student.xprofession.name
          );
        if (this.student.enteredYeare && description)
          description = description.replaceAll(
            "$$START_YEAR",
            this.student.enteredYear
          );
        if (this.student.finishedYeae && description)
          description = description.replaceAll(
            "$$END_YEAR",
            this.student.finishedYear
          );

        this.description = description;
        this.signature = this.item.signature;
      });
    if (this.student.studentCode)
      this._searchStudentScore1(this.student.studentCode);
  },
  mounted() {
    this.nochange = true;
  },
  watch: {
    name: function () {
      this.nochange = false;
    },
    description: function () {
      this.nochange = false;
    },
    signature: function () {
      this.nochange = false;
    },
  },
  methods: {
    _getTranslateString(keyword) {
      if (keyword == "firstName" && this.selectedLanguageType.languageType == 1)
        return this.student.firstName;
      else if (
        keyword == "firstName" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.student.firstNameEN;
      else if (
        keyword == "firstName" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.student.firstNameMB;
    },
    _confirmGPACalculation(allCreditPoints, allCredit) {
      console.log(this.student.ref.path, allCreditPoints, allCredit);

      var datas = {};

      if (allCredit > 0)
        datas._confirmed_calculated_GPA = parseFloat(
          (allCreditPoints / allCredit).toFixed(2)
        );

      datas["_confirmed_calculated_allCreditPoints"] = allCreditPoints;
      datas["_confirmed_calculated_allCredit"] = allCredit;
      datas["_confirmed_calculated_date"] = new Date();

      this.student.ref.update(datas).then(() => {
        console.log(this.student.ref.path, datas);
      });
    },
    _getYearTotalGPAPoints(yearScore) {
      var sum = 0;
      for (const xx of yearScore) {
        sum = sum + xx.gpaTotalPoint;
      }
      return parseFloat(sum);
    },
    _getYearTotalScoreAverageGPA(yearScore, sem) {
      var sum = 0;
      var zz = this._getYearTotalCredit(yearScore, sem);
      for (const xx of yearScore) {
        if (xx.semester == sem) {
          if (xx.lesson && xx.lesson.credit && xx.lesson.credit > 0) {
            sum =
              sum +
              parseFloat(this._getGPAPoint(xx.scoreTotal) * xx.lesson.credit);
          } else sum = sum + 0;
        }
      }
      if (zz > 0) return parseFloat(sum / zz).toFixed(1);
      else return 0;
    },
    _getYearTotalCredit(yearScore, sem) {
      var sum = 0;
      for (const xx of yearScore) {
        if (xx.semester == sem) {
          if (xx.lesson && xx.lesson.credit && xx.lesson.credit > 0) {
            sum = sum + parseFloat(xx.lesson.credit);
          } else sum = sum + 0;
        }
      }
      return sum;
    },

    calculatedScoreTotal2() {
      var xEnteredYear = 2019;
      var xCurrentYear = 2023;
      var sum = 0;
      if (this.yearScores) {
        for (var i = xEnteredYear; i <= xCurrentYear; i++) {
          var datas = this.yearScores[i + "-" + (i + 1 + "-1")];
          if (datas && datas.length > 0) {
            for (var k = 0; k < datas.length; k++) {
              if (datas[k].lesson && datas[k].lesson.credit) {
                sum = sum + parseFloat(datas[k].lesson.credit);
              }
            }
          }
        }
      }
      console.log(sum);
      return sum;
    },
    _getGPAString(score) {
      if (95 <= score && score <= 100) return "A+";
      else if (90 <= score && score <= 94) return "A";
      else if (87 <= score && score <= 89) return "B+";
      else if (80 <= score && score <= 86) return "B";
      else if (77 <= score && score <= 79) return "C+";
      else if (70 <= score && score <= 76) return "C";
      else if (60 <= score && score <= 69) return "D";
      else return "F,W,WF";
    },
    _getGPAPoint(score) {
      if (95 <= score && score <= 100) return 4;
      else if (90 <= score && score <= 94) return 3.7;
      else if (87 <= score && score <= 89) return 3.3;
      else if (83 <= score && score <= 86) return 3;
      else if (80 <= score && score <= 82) return 2.7;
      else if (77 <= score && score <= 79) return 2.3;
      else if (73 <= score && score <= 76) return 2;
      else if (70 <= score && score <= 72) return 1.7;
      else if (65 <= score && score <= 69) return 1.3;
      else if (60 <= score && score <= 64) return 1;
      else return 0;
    },
    _getScoreYear(str) {
      if (str) {
        var x = str.lastIndexOf("-");
        if (x > 0) return str.substring(0, x);
        else null;
      } else return str;
    },

    _getScoreSemester(str) {
      if (str) {
        var x = str.lastIndexOf("-");
        if (x > 0) return str.substring(x + 1);
        else null;
      } else return str;
    },
    _getScoreSemester2(score) {
      if (score.year) {
        var x = score.year.lastIndexOf("-");
        if (x > 0) return score.year.substring(x + 1);
        else null;
      } else return score.year;
    },
    _print() {
      const localOptions = {
        styles: [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          "https://unpkg.com/kidlat-css/css/kidlat.css",
          "./print.css",
        ],
      };
      this.$htmlToPaper("printMe", localOptions);
    },
    _searchStudentScore1(studentCode) {
      fb.db
        .collectionGroup("yearScores")
        .where("studentCode", "==", studentCode)
        .onSnapshot((querySnapshot) => {
          var counter = 0;
          this.studentScores = [];
          this.allCreditPoints = 0;
          querySnapshot.forEach(async (doc) => {
            let score = doc.data();
            score.ref = doc.ref;
            score.id = doc.id;
            score.index = ++counter;
            score.lesson = null;

            if (score.lessonCode) {
              var datas = await fb.db
                .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
                .where("code", "==", score.lessonCode)
                .limit(1)
                .get();
              if (!datas.empty) {
                var doc = datas.docs[0];
                if (doc != null && doc.exists) {
                  score.lesson = doc.data();
                }
              } else {
                var datas = await fb.db
                  .collection(
                    "/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/"
                  )
                  .where("code", "==", score.lessonCode.toUpperCase())
                  .limit(1)
                  .get();
                if (!datas.empty) {
                  var doc = datas.docs[0];
                  if (doc != null && doc.exists) {
                    score.lesson = doc.data();
                  }
                }
              }
            }
            if (!score.lesson.isDiplomLesson) {
              score.year = score.ref.parent.parent.id;
              if (score.semester) {
                score.semester = score.semester;
              } else {
                if (score.lessonRef) {
                  var tt = await score.lessonRef.get();
                  if (tt.data().semesterRef) {
                    var sem = await tt.data().semesterRef.get();
                    score.semester = sem.data().shortName == "Намар" ? 1 : 2;
                  } else {
                    score.semester = "NOS";
                  }
                } else {
                  //xTODO NOWAY TODO DANGEROUS
                  var dd = score.createdAt.toDate();
                  if (dd.getFullYear() == "2023" && dd.getMonth() + 1 < 2) {
                    score.semester = 1;
                  } else {
                    score.semester = "ERROR - ERROR";
                  }
                }
              }
              this.yearScores[score.ref.parent.parent.id].push(score);
              if (score.lesson && score.lesson.credit) {
                this.allCredit =
                  this.allCredit + parseFloat(score.lesson.credit);
              }
              this.allCounter++;
              this.allScore = this.allScore + score.scoreTotal;

              if (score.lesson && score.lesson.credit > 0) {
                this.allCreditPoints =
                  this.allCreditPoints +
                  parseFloat(
                    this._getGPAPoint(score.scoreTotal) * score.lesson.credit
                  );

                score.gpaTotalPoint = parseFloat(
                  this._getGPAPoint(score.scoreTotal) * score.lesson.credit
                );
              } else {
                fb.db
                  .collection("_errored_scores")
                  .doc()
                  .set({ link: score.ref.path })
                  .then(() => {
                    this.student.ref.update({ _errorScores: true });
                  });
              }
              this.studentScores.push(score);
            }
          });
          if (querySnapshot.empty) {
            this.errorMessage = "No Score!";
          }
          console.log(this.allCreditPoints);
        });
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>
<style>
.btable {
  border-collapse: collapse;
  border: 1px solid black;
}
.btable th,
td {
  border: 1px solid black;
  padding: 8px;
}

.scoreBorderedTable {
  border-collapse: collapse;
}
.scoreTableTodorhoilolt-hcell {
  border: 1px solid black;
  text-align: left;
  padding: 8px;
  font-weight: bold !important;
}
.scoreTableTodorhoilolt-cell {
  border: 1px solid black;
  text-align: center;
  border-spacing: 0px !important;
  padding: 0px;
  cursor: pointer;
}
</style>
